import isEqual from 'lodash/isEqual';

/**
 * helper function that validates whether the Row's shouldComponenUpdate function should fire
 */
export const shouldComponentUpdate = ({ columns, rowData, selectable, selected }, props) =>
  !rowData ||
  !isEqual(props.rowData, rowData) ||
  props.selectable !== selectable ||
  props.selected !== selected ||
  !isEqual(props.columns, columns);
